"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interactionToNextPaint = void 0;
var _attribution = require("web-vitals/attribution");
var _vitalMetric = require("./vital-metric");
var _constants = require("./constants");
var _runtime = require("../constants/runtime");
const interactionToNextPaint = exports.interactionToNextPaint = new _vitalMetric.VitalMetric(_constants.VITAL_NAMES.INTERACTION_TO_NEXT_PAINT);
if (_runtime.isBrowserScope) {
  /* Interaction-to-Next-Paint */
  (0, _attribution.onINP)(({
    value,
    attribution,
    id
  }) => {
    const attrs = {
      metricId: id,
      eventTarget: attribution.eventTarget,
      eventType: attribution.eventType,
      eventTime: attribution.eventTime,
      loadState: attribution.loadState
    };
    interactionToNextPaint.update({
      value,
      attrs
    });
  });
}